import React, { useEffect, useRef, useState } from "react";
import "../styles/Iframe.css";

// import { faClose } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import TeacherStudentHeader from "../components/TeacherStudentHeader";

const iFrameURL = process.env.REACT_APP_ANAVU_IFRAME;

export default function Iframe() {
  const iframeRef = useRef(null);
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState("iframe");
  const [isVideoMode, setIsVideoMode] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [receivedMessages, setReceivedMessages] = useState([]); // State to store received messages

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const name = localStorage.getItem("name");
    const user_id = localStorage.getItem("user_id");

    if (!token || !name || !user_id) {
      console.warn("⚠️ Missing required localStorage data");
      return;
    }

    const data = { token, name, user_id, enableDarkMode: true }; // Add enableDarkMode flag

    const sendMessage = () => {
      if (iframeRef.current?.contentWindow) {
        console.log("📩 Sending Message to Trame:", data);
        iframeRef.current.contentWindow.postMessage(
          { message: JSON.stringify(data) },
          iFrameURL
        );
      }
    };


    // Message receiver function
    const handleMessage = (event) => {
      // Security check: verify the origin matches your iframe URL
      console.log("Event origin:", event.origin);
      const iframeOrigin = new URL(iFrameURL).origin;
      if (event.origin !== iframeOrigin) {
        console.warn("⚠️ Message from unauthorized origin:", event.origin, event.data);
        return;
      }

      console.log("📨 Received Message from Trame:", event.data);
      
      // Store the received message
      setReceivedMessages(prev => [...prev, {
        data: event.data,
        timestamp: new Date().toISOString(),
        origin: event.origin
      }]);
      // Handle specific message types here
      const data = JSON.parse(event.data || "{}");
      if (data.type) {
        switch (data.type) {
          case 'iframe-ready':
            // Iframe is ready, resend the initial data
            sendMessage();
            break;
          case 'navigation':
            // Handle navigation requests from iframe
            if (data.route) {
              navigate(data.route);
            }
            break;
          case 'data-update':
            // Handle data updates from iframe
            console.log("Data update received:", data.payload);
            break;
          case 'error':
            // Handle error messages from iframe
            console.error("Error from iframe:", data.message);
            break;
          default:
            // Handle other message types
            console.log("Unknown message type:", data.type);
        }
      }
    };

    // Add message event listener
    window.addEventListener("message", handleMessage);

    // if (iframeRef.current) {
    //   iframeRef.current.onload = sendMessage; // Send the message when iframe loads
    // }

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [navigate]); // Include navigate in dependencies

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const handleActiveItemChange = (item) => {
    setActiveItem(item);
    if (item === "home") {
      navigate("/teacher");
    } else if (item === "feedback") {
      navigate("/teacherFeedback");
    } else if (item === "anavu-web-beta") {
      navigate("/lessons");
    } else if (item === "Download") {
      navigate("/teacher/download");
    }
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setActiveItem(""); // No active menu item during search
  };

  const teacherMenuItems = [
    { icon: null, label: "Download", key: "Download" },
    { icon: null, label: "Dashboard", key: "home" },
    { icon: null, label: "Feedback", key: "feedback" },
    { icon: null, label: "AnaVu Web", key: "iframe" },
  ];

  return (
    <>
      <TeacherStudentHeader
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={false}
        showToggle={false}
        showUserProfile={true}
        searchQuery={searchQuery}
        onSearch={handleSearch}
        teacherMenuItems={teacherMenuItems}
        activeItem={activeItem}
        setActiveItem={handleActiveItemChange}
      />
      {/* <div>
        <div
          className="close-btn"
          onClick={() => {
            navigate(-1);
          }}
        >
          <FontAwesomeIcon icon={faClose} className="close-icon" />
        </div>
      </div> */}

      {/* eslint-disable-next-line */}
      <iframe
        ref={iframeRef}
        src={iFrameURL}
        className="iframe-container"
        allowFullScreen
      />
    </>
  );
}
